"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeClassNameComponent;
exports.makeClassNameComponentCustom = makeClassNameComponentCustom;

var React = _interopRequireWildcard(require("react"));

var _nameHoc = _interopRequireDefault(require("./nameHoc"));

var _classify = _interopRequireDefault(require("./classify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function makeClassNameComponent(baseClassName, // $FlowFixMe not sure how to type this correctly
ComponentType = 'div', name) {
  return /*#__PURE__*/React.forwardRef( // $FlowFixMe[escaped-generic]
  nameComponent(({
    className,
    ...props
  }, ref) =>
  /*#__PURE__*/
  // $FlowFixMe[escaped-generic]
  React.createElement(ComponentType, _extends({}, props, {
    ref: ref,
    className: (0, _classify.default)(baseClassName, className)
  })), "CNC(".concat(name || ComponentType, ")")));
}

function makeClassNameComponentCustom(baseClassName, ComponentType) {
  return /*#__PURE__*/React.forwardRef((0, _nameHoc.default)(({
    className,
    ...props
  }, ref) => /*#__PURE__*/React.createElement(ComponentType, _extends({}, props, {
    ref: ref,
    className: (0, _classify.default)(baseClassName, className)
  })), ComponentType, 'CNC'));
}

function nameComponent(component, name) {
  component.displayName = name;
  return component;
}